import { brandAggregationFields } from './fragments/brand-aggregation-fields'
import { departmentAggregationFields } from './fragments/department-aggregation-fields'
import { sizeTypeAggregationFields } from './fragments/size-type-aggregation-fields'
import { subCategoriesAggregationFields } from './fragments/sub-categories-aggregation-fields'
import { searchProductsParams } from './params/search-products-params'
import { filtersVariables } from './variables/filters-variables'
import { storeVariables } from './variables/store-variables'

export const querySearchAggregationsForStore = /* GraphQL */ `
  query searchAggregationsForStore(
    $term: String!,
    ${filtersVariables},
    ${storeVariables}
  ) {
    seller(id: $seller_id, ownerID: $owner_id) {
      search(products: ${searchProductsParams}) {
        products {
          aggregations {
            departments {
              ...departmentAggregationFields
            }
            brands {
              ...brandAggregationFields
            }
            size_types {
              ...sizeTypeAggregationFields
            },
            relevant_sub_categories {
              ...subCategoriesAggregationFields
            }
          }
        }
      }
    }
  }

  ${departmentAggregationFields}
  ${brandAggregationFields}
  ${sizeTypeAggregationFields}
  ${subCategoriesAggregationFields}
`
